import {useQuery} from 'react-query';
import {useMemo} from 'react';
import {fetchCustomLists} from '../requests/queries/flows';

export const useCustomLists = () => {
  const {data, isLoading, isFetching} = useQuery(['custom-lists'], () =>
    fetchCustomLists({params: {limit: 10000, page: 1}}),
  );

  const customLists = useMemo(
    () =>
      (!isLoading &&
        data &&
        data?.lists?.map(list => ({
          value: list._id,
          label: list.name,
          author: list?.author,
        }))) ||
      [],
    [data, isLoading],
  );

  return {customLists, isLoading: isLoading || isFetching};
};
